export const SESSION_STORAGE_KEY = "perfectserve-interactions-lastSession";
export class SessionStorageService {
    static saveSession(data) {
        try {
            const sessionData = {
                ...data,
                lastSaved: new Date().toISOString(),
                version: "1.0.0",
            };
            localStorage.setItem(SESSION_STORAGE_KEY, JSON.stringify(sessionData));
        }
        catch (error) {
            console.error("Failed to save session data:", error);
        }
    }
    static loadSession() {
        try {
            const stored = localStorage.getItem(SESSION_STORAGE_KEY);
            if (!stored)
                return null;
            const sessionData = JSON.parse(stored);
            if (!sessionData.lastSaved || !sessionData.version) {
                console.warn("Invalid session data structure, clearing...");
                this.clearSession();
                return null;
            }
            return sessionData;
        }
        catch (error) {
            console.error("Failed to load session data:", error);
            this.clearSession();
            return null;
        }
    }
    static clearSession() {
        try {
            localStorage.removeItem(SESSION_STORAGE_KEY);
        }
        catch (error) {
            console.error("Failed to clear session data:", error);
        }
    }
    static hasSession() {
        try {
            return localStorage.getItem(SESSION_STORAGE_KEY) !== null;
        }
        catch (error) {
            return false;
        }
    }
    static getLastSavedTime() {
        const session = this.loadSession();
        return session ? new Date(session.lastSaved) : null;
    }
}
//# sourceMappingURL=sessionStorage.js.map